var map = {
	"./bg-login-page-dark.svg": 48275,
	"./bg-login-page.svg": 49858,
	"./bg-main-dark.svg": 38573,
	"./bg-main.svg": 6256,
	"./consent-image.png": 12317,
	"./error-illustration.svg": 30162,
	"./food-beverage-1.jpg": 67711,
	"./food-beverage-10.jpg": 50927,
	"./food-beverage-11.jpg": 74546,
	"./food-beverage-12.jpg": 93501,
	"./food-beverage-13.jpg": 67936,
	"./food-beverage-14.jpg": 8243,
	"./food-beverage-15.jpg": 52982,
	"./food-beverage-16.jpg": 86241,
	"./food-beverage-17.jpg": 8196,
	"./food-beverage-18.jpg": 96407,
	"./food-beverage-19.jpg": 8890,
	"./food-beverage-2.jpg": 336,
	"./food-beverage-3.jpg": 45229,
	"./food-beverage-4.jpg": 29030,
	"./food-beverage-5.jpg": 19139,
	"./food-beverage-6.jpg": 73076,
	"./food-beverage-7.jpg": 61233,
	"./food-beverage-8.jpg": 73770,
	"./food-beverage-9.jpg": 41511,
	"./icon/alert-circle.svg": 64428,
	"./icon/baby-boy.png": 3272,
	"./icon/book-open.svg": 13509,
	"./icon/boxing-glove.png": 85524,
	"./icon/cloud-lightning.svg": 52071,
	"./icon/dollar-sign.svg": 30509,
	"./icon/female.png": 63089,
	"./icon/fit.png": 37448,
	"./icon/heart.svg": 71189,
	"./icon/home.svg": 34350,
	"./icon/id-card.png": 15319,
	"./icon/kid.png": 70961,
	"./icon/main/age_range/adolescence.png": 80285,
	"./icon/main/age_range/adult.png": 9405,
	"./icon/main/age_range/child.png": 18831,
	"./icon/main/age_range/elderly.png": 25200,
	"./icon/main/age_range/youngchild.png": 81271,
	"./icon/main/issue_based/adolescent_pregnancy.png": 9903,
	"./icon/main/issue_based/bedridden.png": 23748,
	"./icon/main/issue_based/beggar.png": 62039,
	"./icon/main/issue_based/disabled.png": 86575,
	"./icon/main/issue_based/family_violence.png": 13775,
	"./icon/main/issue_based/helpless.png": 66741,
	"./icon/main/issue_based/hiv_affected.png": 44747,
	"./icon/main/issue_based/homeless.png": 82937,
	"./icon/main/issue_based/human_trafficking.png": 58115,
	"./icon/main/issue_based/single_parents.png": 50941,
	"./icon/male.png": 85174,
	"./icon/man.png": 34737,
	"./icon/map-pin.svg": 79997,
	"./icon/old-man.png": 40045,
	"./icon/pause-svg.svg": 55446,
	"./icon/payment-method.png": 85617,
	"./icon/play-alt-svg.svg": 67106,
	"./icon/teenager.png": 97028,
	"./icon/x.svg": 61673,
	"./illustration.svg": 2541,
	"./logo.svg": 3914,
	"./logo/BORA.png": 53665,
	"./logo/CSG.png": 25794,
	"./logo/DEP.png": 71160,
	"./logo/VSMART.png": 42102,
	"./logo/csg.jpg": 53638,
	"./main/banner-msologbook-V2.2.jpg": 45965,
	"./main/banner-msologbook.jpg": 69374,
	"./main/logo-msologbook.png": 41183,
	"./main/v1.png": 25274,
	"./map-marker-region.png": 13513,
	"./map-marker.png": 22354,
	"./pdf-logo.jpeg": 26438,
	"./phone-illustration.svg": 10824,
	"./placeholders/200x200.jpg": 4112,
	"./placeholders/800x800.jpg": 6080,
	"./preview-1.jpg": 52297,
	"./preview-10.jpg": 19669,
	"./preview-11.jpg": 28760,
	"./preview-12.jpg": 91335,
	"./preview-13.jpg": 52330,
	"./preview-14.jpg": 81273,
	"./preview-15.jpg": 67548,
	"./preview-16.jpg": 35243,
	"./preview-17.jpg": 8782,
	"./preview-18.jpg": 23789,
	"./preview-19.jpg": 80336,
	"./preview-2.jpg": 72702,
	"./preview-3.jpg": 74011,
	"./preview-4.jpg": 92424,
	"./preview-5.jpg": 20037,
	"./preview-6.jpg": 32186,
	"./preview-7.jpg": 3351,
	"./preview-8.jpg": 15140,
	"./preview-9.jpg": 93185,
	"./profile-1.jpg": 55774,
	"./profile-10.jpg": 49220,
	"./profile-11.jpg": 27265,
	"./profile-12.jpg": 94006,
	"./profile-13.jpg": 49267,
	"./profile-14.jpg": 8960,
	"./profile-15.jpg": 34525,
	"./profile-16.jpg": 15570,
	"./profile-17.jpg": 91951,
	"./profile-18.jpg": 31116,
	"./profile-19.jpg": 86377,
	"./profile-2.jpg": 35369,
	"./profile-3.jpg": 80108,
	"./profile-4.jpg": 86423,
	"./profile-5.jpg": 98906,
	"./profile-6.jpg": 3109,
	"./profile-7.jpg": 59144,
	"./profile-8.jpg": 98259,
	"./profile-9.jpg": 42998,
	"./woman-illustration.svg": 19198
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73811;